import { Calendar, DatePicker, Descriptions, Tag, Space, Typography, Col, Row} from '@douyinfe/semi-ui';
import { useState, useEffect } from 'react'
import axios from 'axios';

export function DatePickerL({displayDate, setSelectedDate, setDisplayDate, holiday}) {

    return (
        <DatePicker
            value={displayDate}
            showClear={false}
            type="month"
            onChange={date => {
                if (!Object.keys(holiday).includes(date.toLocaleDateString())) {
                    setSelectedDate({})
                    return null
                };
                const dateDetail = holiday[date.toLocaleDateString()]
                setSelectedDate(dateDetail)
                setDisplayDate(date)
            }}
            disabledDate={date => date.getFullYear() !== new Date().getFullYear()}
            presets={[
                {text: '今天', start: new Date(), end: new Date()}
            ]}
        />
    )
}

export function CalendarL({displayDate, setDisplayDate, setSelectedDate, holiday}) {
    
    return (
        <Calendar
            mode={'month'}
            height={'100%'}
            weekStartsOn={1}
            displayValue={displayDate}
            onClick={(event, date) => {
                if (!Object.keys(holiday).includes(date.toLocaleDateString())) {
                    setSelectedDate({})
                    return null
                };
                const dateDetail = holiday[date.toLocaleDateString()]
                setSelectedDate(dateDetail)
                setDisplayDate(new Date(dateDetail?.detail?.timestamp * 1000))
            }}
            renderDateDisplay={date => null}
            dateGridRender={
                dateString => {
                    const date = new Date(dateString)
                    if (!Object.keys(holiday).includes(date.toLocaleDateString())) return null;
                    
                    const holidayStyle = {
                        position: 'absolute',
                        top: 0, bottom: 0, left: 0, right: 0,
                        display: 'grid', textAlign: 'center', placeItems: 'center',
                        cursor: 'pointer'
                    }
                    
                    const dateDetail = holiday[date.toLocaleDateString()]
                    
                    if (dateDetail?.status !== 0) holidayStyle.color = 'rgba(var(--semi-red-6), 1)';
                    if (dateDetail?.status === 2) holidayStyle.backgroundColor = 'rgba(var(--semi-red-1), 1)';
                    
                    if (date.toLocaleDateString() === new Date().toLocaleDateString()) holidayStyle.border = 'var(--semi-color-primary) 1px solid';
                    
                    if (date.getMonth() !== displayDate.getMonth()) holidayStyle.backgroundColor = 'rgba(var(--semi-grey-1), 1)';
                    let day = date.getDate() === 1 ? `${date.getMonth() + 1}月` : date.getDate();
                    
                    if (dateDetail?.status === 2) day = <div style={{display: 'grid'}}> <div>{day}</div><div>休</div> </div>;
                    if (dateDetail?.status === 0 && dateDetail?.value === '补班日') day = <div style={{display: 'grid', color: 'rgba(var(--semi-grey-6), 1)'}}> <div>{day}</div><div>班</div> </div>;
                    
                    if (date.toLocaleDateString() === displayDate?.toLocaleDateString()) holidayStyle.backgroundColor = 'rgba(var(--semi-light-blue-1), 1)';
                    
                    return <div style={holidayStyle} > {day} </div>

                }
            }
        />
    )
}

export function DescriptionsL({selectedDate}) {

    const {Text} = Typography

    return(
        <>
            {
                Object.keys(selectedDate).length > 0 &&
                <Descriptions>
                    <Descriptions.Item itemKey={'公历'}><Text strong>{`${selectedDate?.detail?.year}年${selectedDate?.detail?.month}月${selectedDate?.detail?.day}日`}</Text></Descriptions.Item>
                    <Descriptions.Item itemKey="农历">{`${selectedDate?.detail?.lMonth}月${selectedDate?.detail?.lDate}`}</Descriptions.Item>
                    <Descriptions.Item itemKey="干支">{`${selectedDate?.detail?.gzYear}年 ${selectedDate?.detail?.gzMonth}月 ${selectedDate?.detail?.gzDate}日`}</Descriptions.Item>
                    <Descriptions.Item itemKey="生肖">{selectedDate?.detail?.animal}</Descriptions.Item>
                    <Descriptions.Item itemKey="节假日" >
                        {selectedDate?.status === 0 ? <Tag color='grey'> {selectedDate?.value} </Tag> : <Tag color='red'>{selectedDate?.value}</Tag>}
                    </Descriptions.Item>
                    <Descriptions.Item itemKey="宜">
                        <Space wrap>{selectedDate?.detail?.suit?.split(/\./g).map(item => <Tag color='green'>{item}</Tag>)}</Space>
                    </Descriptions.Item>
                    <Descriptions.Item itemKey="忌">
                        <Space wrap>{selectedDate?.detail?.avoid.split(/\./g).map(item => <Tag color='orange'>{item}</Tag>)}</Space>
                    </Descriptions.Item>
                    {
                        selectedDate?.detail?.festivalList &&
                        <Descriptions.Item itemKey="节日">
                            <Space wrap>
                                {selectedDate?.detail?.festivalInfoList?.map(item => <Tag style={{cursor: 'pointer'}} onClick={() => window.open(item?.baikeUrl, '_blank')}>{item?.baikeName}</Tag>)}
                            </Space>
                        </Descriptions.Item>
                    }
                </Descriptions>
            }
        </>
    )
}

export function ContentRight() {
    
    const [holiday, setHoliday] = useState({})
    const [selectedDate, setSelectedDate] = useState({})
    const [displayDate, setDisplayDate] = useState(new Date())

    useEffect(() => {
        axios.get('https://wongjinggitt.github.io/public/holiday.json')
        .then(res => {
            setHoliday(res.data)
            if (!Object.keys(res.data).includes(new Date().toLocaleDateString())) return null;
            setSelectedDate(res.data[new Date().toLocaleDateString()])
        })
    
    }, [])

    return (
        <>
            <Row style={{height: '3%', marginTop: 10}}>
                <Col offset={1} span={22}>
                    <DatePickerL 
                        setDisplayDate={setDisplayDate}
                        setSelectedDate={setSelectedDate}
                        holiday={holiday}
                        displayDate={displayDate}
                    />
                </Col>
            </Row>
            <Row style={{height: '30%', marginTop: 15}}>
                <Col offset={1} span={22} style={{height: '100%'}}>
                    <CalendarL 
                        setDisplayDate={setDisplayDate}
                        setSelectedDate={setSelectedDate}
                        holiday={holiday}
                        displayDate={displayDate}
                    />
                </Col>
            </Row>
            <Row style={{height: '50%', marginTop: 15, width: '95%'}}>
                <Col offset={1} span={22} style={{height: '100%', overflow: 'auto', width: '100%'}}>
                    <DescriptionsL 
                        selectedDate={selectedDate}
                    />
                </Col>
            </Row>
        </>
    )


}